import React from 'react'
import { Card, Flex, Typography } from 'antd'

type Props = {
  id: string
  currencies: string[]
}
export const GeneralCardDetails: React.FC<Props> = ({ id, currencies }) => {
  return (
    <Card style={{ height: 300 }}>
      <Typography.Title level={3}>General</Typography.Title>
      <Flex gap={60}>
        <Flex vertical>
          <Typography.Text
            style={{ fontSize: '18px', textWrap: 'nowrap' }}
            type="secondary"
          >
            ID
          </Typography.Text>
          <Typography.Text style={{ fontSize: '18px' }}>{id}</Typography.Text>
        </Flex>
        <Flex vertical>
          <Typography.Text style={{ fontSize: '18px' }} type="secondary">
            Currencies
          </Typography.Text>
          <Typography.Text style={{ fontSize: '18px' }}>
            {currencies?.join('  ')}
          </Typography.Text>
        </Flex>
      </Flex>
    </Card>
  )
}
